/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-radio-button-checked': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm0 16.25a7.5 7.5 0 110-15 7.5 7.5 0 010 15zm0-11.25a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5z"/>'
  }
})
